

import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../utils";
import { createCompanyPreference, listCompanyPreference } from '../../graphql';
import type {
CompanyPreference,
CreateCompanyPreferenceMutationVariables,
ListCompanyPreferenceQuery
} from "../../graphql/API";


// ------------------- API -------------------

export const companyPreferenceApi = createApi({
  reducerPath: 'companyPreferenceApi',
  tagTypes: ['listCompanyPreference'],
  baseQuery,
  endpoints: (builder) => ({
    /**
     * Fetch list of company preferences
     */
    listCompanyPreference: builder.query<CompanyPreference[], void>({
      query: () => ({ body: listCompanyPreference }),
      keepUnusedDataFor: 300,
      transformResponse: (response: ListCompanyPreferenceQuery): CompanyPreference[] =>
        (response?.listCompanyPreference ?? [])
          .filter((item): item is CompanyPreference => item !== null),
      providesTags: ["listCompanyPreference"],
    }),
    /**
     * Create or update a company preference
     */
    createCompanyPreference: builder.mutation<
      { createCompanyPreference: CompanyPreference },
      CreateCompanyPreferenceMutationVariables
    >({
      query: (variables) => ({
        body: createCompanyPreference,
        variables,
      }),
      invalidatesTags: ['listCompanyPreference'],
    }),
  }),
});

// ------------------- EXPORT HOOKS -------------------

export const {
  useListCompanyPreferenceQuery,
  useCreateCompanyPreferenceMutation,
} = companyPreferenceApi;


